<template>
  <v-navigation-drawer permanent :mini-variant="isMinified" app floating class="Drawer">
    <div class="Drawer-bg">
      <v-list nav class="pa-0">
        <v-list-item
          v-for="navItem in navItems"
          :to="{ name: navItem.routeName }"
          :key="navItem.routeName"
          :class="isMinified ? 'justify-center' : 'pa-4 pl-8'"
        >
          <v-list-item-icon class="pl-sm-0" :class="{ 'mr-5': !isMinified }">
            <v-icon class="Item-icon" color="white">{{ navItem.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="Item-title">{{ navItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout" class="Logout-container" link>
          <v-list-item-icon v-if="isMinified" class="ma-0">
            <v-icon @click="logout" color="white">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <div class="Logout-title white--text">{{ $t('sidebar.logoutButton') }}</div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div class="Sidebar-border"></div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import auth from '@/services/auth'

export default {
  name: 'Sidebar',
  data() {
    return {
      navItems: [
        { routeName: 'Calendar', title: this.$t('sidebar.calendarTitle'), icon: 'mdi-calendar' },
        { routeName: 'Settings', title: this.$t('sidebar.settingsTitle'), icon: 'mdi-cog' },
        { routeName: 'Manage', title: this.$t('sidebar.manageTitle'), icon: 'mdi-bookmark' },
        { routeName: 'Account', title: this.$t('sidebar.accountTitle'), icon: 'mdi-account-circle' }
        // { routeName: 'Reports', title: this.$t('sidebar.reportsTitle'), icon: 'mdi-database' }
      ]
    }
  },
  computed: {
    isMinified() {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    }
  },
  methods: {
    async logout() {
      await auth.logout()
      await this.$router.push({ name: 'Login' })
      this.$store.commit('RESET_STORE')
    }
  }
}
</script>

<style scoped lang="scss">
$color-white: #fff;
$color-bg: rgba(69, 76, 94, 0.9);
$color-border: #a8a8a8;

.v-navigation-drawer .v-list {
  background: none;
}

.Drawer {
  background-image: url('../../assets/sidebar-background-essilor.jpg');
  height: 100vh;
  background-size: cover;
  background-position: center;
}

.Drawer-bg {
  height: 100vh;
  background-color: $color-bg;
}

.Item-title,
.Item-icon {
  font-weight: 300;
}

.Item-title {
  font-size: 0.9rem;
  color: #fff;
}

.v-list-item--active {
  .Item-title {
    font-size: 0.95rem;
    font-weight: 900;
  }
}

.Logout-container {
  bottom: 50px;
  font-weight: bold;
  padding: 16px !important;
  position: absolute;
  text-align: center;
  width: 100%;
  .Logout-title {
    font-weight: bold;
  }
}

.Sidebar-border {
  height: 100%;
  background-color: $color-border;
  border-left: 1px solid $color-white;
  position: absolute;
  right: 0;
  top: 0;
  width: 2px;
}
</style>

<style lang="scss">
.App-galileo .Drawer-bg {
  background-color: rgba(0, 163, 110, 0.85);
}
.App-nikon .Drawer-bg, .App-nikon-it .Drawer-bg {
  background-color: rgba(0, 0, 0, 0.85);
}
</style>

<style lang="scss">
.App-galileo .Drawer {
  background-image: url('../../assets/sidebar-background-galileo.jpg');
}

.App-nikon .Drawer, .App-nikon-it .Drawer {
  background-image: url('../../assets/sidebar-background-nikon-it.jpg');
}
</style>
